const ScoirIcon = () => {
  return (
    <svg
      id="icon-scoir_logo"
      viewBox="0 0 200 200"
    >
      <title>scoir_logo</title>
      <path
        d="M87,67.6c-2.5-8.5-18.3-16-30.3-16c-24.6,0-42.6,17.6-43,42.5c-0.4,22.4,19.2,45.3,43.7,45.3
	c38.9,0,50.4-39.2,63.3-55.9c5.6-7.2,10.9-12.7,22.3-12.7c13.6,0,22.9,12,22.9,25.2c0,13-10.3,23.4-23.9,23.4c-8,0-20-6.2-23.9-11.7
	c0,0-10.7,15.1-10.3,15.6c3.7,4.2,15.4,16.7,33.8,16.7c25.2,0,44.8-18.4,44.8-43c0-24.5-17.3-45.3-44.8-45.3c-47,0-43.9,66-83.7,66
	c-13,0-24.4-9.2-24.4-26.5c0-16.8,13.8-27.2,26.7-29.2c5.7-0.9,17.4-0.3,26.7,5.9L87,67.6z"
      />
    </svg>
  )
}

export default ScoirIcon
